// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b172289a","455":"d6eec966"}[chunkId] + ".chunk.js";
};